<template>
  <el-dialog
    v-if="fullscreen"
    id="logs-fullscreen"
    title="Press esc to exit full screen"
    :visible.sync="visible"
    fullscreen
    @close="$emit('update:fullscreen', false)"
  >
    <div v-html="html" class="logs" />
  </el-dialog>

  <div
    v-else
    v-html="html"
    :style="{ height }"
    class="logs"
  />
</template>

<script>
import _ from 'lodash'
import AnsiUp from 'ansi_up'

export default {
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: 0
    },
    logs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      height: 0,
      visible: this.fullscreen,
      ansi: null
    }
  },
  beforeMount () {
    this.ansi = new AnsiUp()
  },
  computed: {
    html () {
      const content = _.uniq(this.logs).sort().map((log) => log.replace(/^[0-9]{11,}\s/, '').replace(/#033/g, '\x1B')).join('\n')
      return this.ansi.ansi_to_html(content)
        .replace(/#033/g, '\x1B')
        .replace(/\n/gm, '<br>')
    }
  },
  created () {
  },
  updated () {
    this.height = (window.innerHeight - this.offset) + 'px'
    this.$el.scrollTop = this.$el.scrollHeight
  },
  watch: {
    fullscreen (value) {
      this.visible = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .logs {
    min-height: 150px;
    padding: 10px 15px;
    color: #f1f1f1;
    font-size: 12px;
    line-height: 19px;
    white-space: pre-wrap;
    word-wrap: break-word;
    background-color: #222;
    font-family: monospace;
    overflow-y: scroll;
  }
</style>

<style lang="scss">
  #logs-fullscreen {
    overflow-y: hidden;

    .el-dialog__body {
      height: auto !important;
    }
  }
</style>
